import React from 'react'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'
import {
  EMPLOYMENT_TYPE_OPTIONS,
  IJobModel,
  optionLabel,
  WORK_TYPE_OPTIONS,
} from './JobModel'
import {ILocationModel} from '../location/LocationModel'

type Props = {
  data: IJobModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit: (job: IJobModel) => void
  onDelete: (job: IJobModel) => void
  onOpenPublic: (job: IJobModel) => void
  onShare: (job: IJobModel) => void
  onDashboard: (job: IJobModel) => void
  loading?: boolean
}

export const JobTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  onOpenPublic,
  onShare,
  onDashboard,
  loading = false,
}) => {
  const columns: TableColumn<IJobModel>[] = [
    {
      key: 'title',
      label: 'İlan',
      render: (_, job) => (
        <div className='d-flex flex-column'>
          <span className='fw-bolder text-gray-800'>{job.title}</span>
          {job.subTitle && <span className='text-muted fs-7'>{job.subTitle}</span>}
        </div>
      ),
    },
    {
      key: 'locationList',
      label: 'Lokasyon',
      render: (locations: ILocationModel[]) =>
        locations?.length
          ? locations.map((location) => `${location.province} / ${location.district}`).join(', ')
          : '-',
    },
    {
      key: 'workType',
      label: 'Çalışma Şekli',
      width: '130px',
      render: (_, job) => (
        <div className='d-flex flex-column fs-7'>
          <span>{optionLabel(WORK_TYPE_OPTIONS, job.workType)}</span>
          <span className='text-muted'>{optionLabel(EMPLOYMENT_TYPE_OPTIONS, job.employmentType)}</span>
        </div>
      ),
    },
    {
      key: 'status',
      label: 'Durum',
      width: '100px',
      render: (status) =>
        status === 'ACTIVE' ? (
          <span className='badge badge-light-success'>Yayında</span>
        ) : (
          <span className='badge badge-light-secondary'>Pasif</span>
        ),
    },
  ]

  const isPublished = (job: IJobModel) => job.status === 'ACTIVE'

  const actions: TableAction<IJobModel>[] = [
    {
      label: 'İlanı Aç',
      icon: 'bi bi-box-arrow-up-right',
      className: 'btn-light-info me-2',
      onClick: onOpenPublic,
      condition: isPublished,
    },
    {
      label: 'Paylaş',
      icon: 'bi bi-share',
      className: 'btn-light-info me-2',
      onClick: onShare,
      condition: isPublished,
    },
    {
      label: 'Dashboard',
      icon: 'bi bi-bar-chart-line',
      className: 'btn-light-success me-2',
      onClick: onDashboard,
    },
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: onEdit,
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: onDelete,
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz ilan bulunamadı'
    />
  )
}
